<template>
  <div class="con">
    <div class="title">
      <h2>신청 안내</h2>
      <p>신청 전 아래의 정보를 확인 하신 후 신청해 주세요!</p>
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50">
      <div class="apply-fieldset">
        <!-- 다운로드 버튼이 상단 왼쪽일 경우 -->
        <!-- <div class="down-btn-tl">
                            <button>3차수 안내 다운로드</button>
        </div>-->

        <!-- 다운로드 버튼이 상단 오른쪽일 경우 -->
        <div class="down-btn-tr" v-if="buttonPosition === 'T'">
          <button v-if="buttonName1 && buttonFileUrl1" @click="downloadURI(1)">
            {{ buttonName1 }}
          </button>
          <button
            v-if="buttonName2 && buttonFileUrl2"
            @click="downloadURI(2)"
            class="ml-10"
          >
            {{ buttonName2 }}
          </button>
        </div>

        <div class="hq-table-row" v-html="guideContents"></div>

        <!-- 다운로드 버튼이 하단 왼쪽일 경우 -->
        <div class="down-btn-bl" v-if="buttonPosition === 'B'">
          <button v-if="buttonName1 && buttonFileUrl1" @click="downloadURI(1)">
            {{ buttonName1 }}
          </button>
          <button
            v-if="buttonName2 && buttonFileUrl2"
            @click="downloadURI(2)"
            class="ml-10"
          >
            {{ buttonName2 }}
          </button>
        </div>

        <!-- 다운로드 버튼이 하단 오른쪽일 경우 -->
        <!-- <div class="down-btn-br">
                            <button>3차수 안내 다운로드</button>
        </div>-->
      </div>
    </div>
    <div class="apply-agree-btn">
      <button type="button" :class="setButtonColor()" @click="goApply()">
        {{ isFinishPage ? "신청하기" : "다음" }}
      </button>
    </div>
  </div>
</template>

<script>
import ContentDisposition from "content-disposition";

export default {
  data: () => ({
    buttonFileName1: "", // 1번째 버튼 파일 이름
    buttonFileName2: "", // 2번째 버튼 파일 이름
    buttonFileUrl1: "", // 1번째 버튼 파일 url
    buttonFileUrl2: "", // 2번재 버튼 파일 url
    buttonName1: "", // 1번째 버튼 이름
    buttonName2: "", // 2번째 버튼 이름
    buttonPosition: "", // 버튼 위치 포지션 T: Top, B: Bottom
    guideContents: "", // 가이드 내용 html

    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    isRegPage: false, // 현재 페이지가 신청완료 직전 페이지인지
    pOrder: [], // 프로세스 순서 저장해놓는 배열
    pageType: "info", // 현재 페이지 타입

    pointColor: "blue",
  }),
  mounted() {
    this.pointColor = sessionStorage.getItem("pointColor");

    this.axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    this.axios.defaults.headers.common["Access-Control-Allow-Methods"] =
      "GET,PUT,POST,DELETE,OPTIONS";
    this.axios.defaults.headers.common["Access-Control-Allow-Headers"] =
      "Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Authorization";
    this.axios.defaults.headers.common["Content-Type"] =
      "application/octet-stream";
    this.axios.defaults.headers.common["content-disposition"] = "attachment";
    // TODO: 임시 idx라서 추후에 변경 필요
    var summaryIdx = sessionStorage.getItem("mainIdx");
    var params = {
      summaryIdx: summaryIdx,
    };

    // TODO : 관리자단에서 등록시 버튼에 NAME1에 안들어감, 쥬디님한테 수정 요청 필요
    this.axios
      .get(this.axios.root + this.axios.port + `/sugang/guide/${summaryIdx}`, {
        params: params,
      })
      .then((res) => {
        // console.log("res", res);
        if (res.data.err === 0) {
          (this.buttonFileName1 = res.data.guideInfo.button_file_name1), // 1번째 버튼 파일 이름
            (this.buttonFileName2 = res.data.guideInfo.button_file_name2), // 2번째 버튼 파일 이름
            (this.buttonFileUrl1 = res.data.guideInfo.button_file_url1), // 1번째 버튼 파일 url
            (this.buttonFileUrl2 = res.data.guideInfo.button_file_url2), // 2번재 버튼 파일 url
            (this.buttonName1 = res.data.guideInfo.button_name1), // 1번째 버튼 이름
            (this.buttonName2 = res.data.guideInfo.button_name2), // 2번째 버튼 이름
            (this.buttonPosition = res.data.guideInfo.button_position), // 버튼 위치 포지션 T: Top, B: Bottom
            (this.guideContents = res.data.guideInfo.guide_contents); // 가이드 내용 html
        } else {
          alert(res.data.result);
        }
      });

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    this.pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (finishPage === "complete") {
      if (pageType === pOrder[pOrder.length - 2]) {
        this.isRegPage = true;
      }
    }

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }
  },

  methods: {
    downloadFile(url) {
      //네이버 클라우드 CORS 오류로 storage/download-object 사용
      const url_arr = url.split("/");
      const fileName = url_arr[url_arr.length - 1];
      const folderName = url_arr[url_arr.length - 2];
      const download_url =
        this.axios.root +
        this.axios.port +
        "/storage/download-object?fileName=" +
        fileName +
        "&folderName=" +
        folderName;
      const link = document.createElement("a");
      link.setAttribute("download", fileName);
      link.href = download_url; //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    setButtonColor() {
      if (this.pointColor === "Blue") {
        return "blue";
      } else if (this.pointColor === "Red") {
        return "red";
      } else if (this.pointColor === "Green") {
        return "green";
      }
    },

    downloadURI(num) {
      var url = "";
      var fileName = "";
      if (num === 1) {
        url = this.buttonFileUrl1;
        var splitUrl = url.split("/");
        var splitUrlLength = splitUrl.length;
        fileName = splitUrl[splitUrlLength - 1];
      } else {
        url = this.buttonFileUrl2;
        var splitUrl = url.split("/");
        var splitUrlLength = splitUrl.length;
        fileName = splitUrl[splitUrlLength - 1];
      }

      //window.open(url);
      this.downloadFile(url);
    },

    // '수강신청 하기' 이동
    goApply() {
      if (this.isFinishPage || this.isRegPage) {
        this.save();
      } else {
        var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
        var idx = pOrder.indexOf("info") + 1;
        sessionStorage.setItem("step", pOrder[idx]);
        this.$router.push(`/user/reg/${pOrder[idx]}`);
      }
    },

    // 수강신청 전체 데이터 저장
    async save() {
      var classData = JSON.parse(sessionStorage.getItem("classData"));

      var keys = [
        "mobile",
        "number",
        "optionContents1",
        "optionContents2",
        "optionContents3",
        "optionContents4",
        "optionContents5",
        "optionName1",
        "optionName2",
        "optionName3",
        "optionName4",
        "optionName5",
        "position",
      ];

      // for (var key of keys) [
      //     if (classData[key] === '')
      // ]

      // console.log('classData', classData)
      //   var infoData = JSON.parse(JSON.stringify(this.sessionData["info"]));
      classData["idxItmSugangPageMain"] = sessionStorage.getItem("pageIdx");

      classData["payStatus"] = "X";
      classData["studentSubjectIdx"] = -1;

      var itemNames = [
        "이름",
        "비밀번호",
        "사번",
        "휴대전화번호",
        "직급",
        "부서",
        "회사",
        "공인시험점수",
      ];
      var count = 1;

      for (var item of classData["info"]) {
        if (item.item_name.includes("E-mail@")) {
          continue;
        } else if (itemNames.includes(item.item_name)) {
          continue;
        } else {
          classData["optionName" + count.toString()] = item.item_name;
          classData["optionContents" + count.toString()] = item.value;
          count += 1;
        }
      }

      delete classData["info"];

      classData["type"] = "Y";
      if (classData.classList) {
        delete this.sessionData["totalPayment"];
        classData["programIdx"] = sessionStorage.getItem("programIdx");
      } else {
        classData["type"] = "N";
        classData["orderId"] = "";
        delete classData["classList"];
      }

      let params = classData;

      await this.axios
        .post(
          this.axios.root + this.axios.port + "/user/check-subjectdup",
          params,
        )
        .then((res) => {
          // console.log('res 중복체크', res)
          if (res.data.err === 0) {
            this.axios
              .post(this.axios.root + this.axios.port + "/user/apply", params)
              .then((res) => {
                // console.log("최종 저장 res", res);
                localStorage.setItem("accessToken", res.data.accessToken);
                this.axios.defaults.headers.common["accessToken"] =
                  res.data.accessToken;
                if (res.data.subjectList) {
                  sessionStorage.setItem(
                    "finishData",
                    JSON.stringify(res.data.subjectList),
                  );
                }
                if (res.data.err === 0) {
                  alert("수강신청이 완료되었습니다.");
                  if (this.isFinishPage) {
                    this.$router.push("/user/applyList");
                  } else if (this.isRegPage) {
                    this.$router.push("/user/reg/complete");
                  }
                  // var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                  // var idx = pOrder.indexOf("payment") + 1;
                  // sessionStorage.setItem("step", pOrder[idx]);
                  // sessionStorage.setItem(
                  //     "classData",
                  //     JSON.stringify(this.sessionData)
                  // );
                  // this.$router.push(`/user/reg/${pOrder[idx]}`);
                } else {
                  alert(res.data.result);
                  return false;
                }
              });
          } else {
            alert(res.data.result);
            return false;
          }
        });
    },
  },
};
</script>

<style scoped>
.down-btn-tr {
  margin-bottom: 18px;
}

.down-btn-bl {
  margin-top: 18px;
}

.hq-table-row {
  text-align: center;
}

.hq-table-row :deep(*) {
  text-align: center;
}

.hq-table-row :deep(img) {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
}

.hq-table-row :deep(figure) {
  margin-left: auto !important;
  margin-right: auto !important;
}

.hq-table-row :deep(figure.image),
.hq-table-row :deep(figure.image.image_resized) {
  display: table;
  margin-left: auto !important;
  margin-right: auto !important;
}

.hq-table-row :deep(table) {
  margin-left: auto;
  margin-right: auto;
}

.hq-table-row :deep(video),
.hq-table-row :deep(iframe) {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
}
</style>
